import { createAction } from '@reduxjs/toolkit';

import type { FilterGroup } from '@/types/filters';

/**
 * "Signal" actions: intents the UI dispatches for the saga to act on. Kept out
 * of the slice's reducers: they trigger side effects, not state transitions
 * (the saga owns the resulting `load*` transitions).
 */

/** Load the list, its comment count and its facet sources for the given id. */
export const loadRequested = createAction<string>('discoveredLpDetail/loadRequested');

/** Refetch the current page of profiles (after tags added, a profile edited). */
export const profilesRequested = createAction('discoveredLpDetail/profilesRequested');

/** The debounced, pruned server filters changed (resets to the first page). */
export const filtersChanged = createAction<FilterGroup | null>('discoveredLpDetail/filtersChanged');

/** The debounced keyword search changed (resets to the first page). */
export const searchChanged = createAction<string>('discoveredLpDetail/searchChanged');

/** "Ask AI": turn the sentence into filter rules. */
export const aiSearchRequested = createAction<string>('discoveredLpDetail/aiSearchRequested');

/** Navigate to a 0-indexed page. */
export const pageChanged = createAction<number>('discoveredLpDetail/pageChanged');

/** Change the page size (resets to the first page). */
export const pageSizeChanged = createAction<number>('discoveredLpDetail/pageSizeChanged');

/** Reload the Type menu's figures (after a profile's types may have changed). */
export const categoryCountsRequested = createAction('discoveredLpDetail/categoryCountsRequested');

/** Reload the Country and Tags menus' choices (after tags were added). */
export const facetOptionsRequested = createAction('discoveredLpDetail/facetOptionsRequested');
